import { render, staticRenderFns } from "./processes.vue?vue&type=template&id=e472a978"
import script from "./processes.vue?vue&type=script&lang=js"
export * from "./processes.vue?vue&type=script&lang=js"
import style0 from "./processes.vue?vue&type=style&index=0&id=e472a978&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports